module.exports = __webpack_public_path__ + "app/principal/group/modal-group-add-companies-dTgIQu2f.html";